
import initialState from './initialState'

/**
 * Loads initial state
 */
let state = initialState()

export default state